import styles from "./RatingReviewsComponent.module.scss";
import React from "react";
import classNames from "classnames";
export function RatingReviewsComponent(props) {
  var _props$className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.ratingBox, (_props$className = props.className) !== null && _props$className !== void 0 ? _props$className : "")
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "15",
    viewBox: "0 0 16 15",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5716 0.711861C7.76593 0.388951 8.23407 0.388951 8.4284 0.711861L10.5241 4.19411C10.5939 4.31011 10.7077 4.39285 10.8396 4.4234L14.799 5.3404C15.1662 5.42544 15.3109 5.87067 15.0638 6.15528L12.3996 9.22443C12.3108 9.32668 12.2673 9.46054 12.279 9.59543L12.6304 13.6444C12.663 14.0199 12.2843 14.2951 11.9373 14.148L8.19505 12.5626C8.07038 12.5098 7.92962 12.5098 7.80496 12.5626L4.06273 14.148C3.71571 14.2951 3.33697 14.0199 3.36955 13.6444L3.72095 9.59543C3.73266 9.46054 3.68916 9.32668 3.60041 9.22443L0.936184 6.15528C0.68913 5.87067 0.833795 5.42544 1.20095 5.3404L5.16036 4.4234C5.29226 4.39285 5.40613 4.31011 5.47595 4.19411L7.5716 0.711861Z",
    fill: "#12192B",
    fillOpacity: "0.35"
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.ratingNumber
  }, props.rating), /*#__PURE__*/React.createElement("span", {
    className: styles.reviews
  }, props.reviews));
}